<template>
  <div class="wrap" id="i-detail-wrap">
    <div style="width:100%" v-if="mounted">
      <div :class="[child == true ? 'header-individual-child' : header_notification ? 'header-individual full header-notification-space' : 'header-individual full']">
        <div class="search-form">
          <div class="header-tabs" @click="tabs != 'summary' ? changeTab('summary') : ''" :class="tabs == 'summary' ? 'active' : ''">サマリー</div>
          <el-tooltip placement="bottom">
            <div slot="content" class="flex-row">
              <div>Coming Soon!</div>
            </div>
            <div class="header-tabs disabled" :class="tabs == 'analysis' ? 'active' : ''">分析</div>
          </el-tooltip>
          <div class="header-tabs" @click="tabs != 'post' ? changeTab('post') : ''" :class="tabs == 'post' ? 'active' : ''">投稿</div>
          <div class="header-tabs" @click="tabs != 'note' ? changeTab('note') : ''" :class="tabs == 'note' ? 'active' : ''">ノート</div>
          <otherSNS :own_id="profile_data.tw_id" :other_sns="profile_data.other_sns" :similar_data="similar_data" :parent_component="parent_component" :child="child" />
          <div class="flex-space"></div>
        </div>
        <div class="i-detail-similar-button-wrap pointer" v-if="similar_data && !similar_loading" @click="scrollBottom()">
          <div class="i-detail-similar-icon" v-for="similar in similar_account" :key="similar.account_name">
            <el-image :src="similar.profile_picture_url" class="i-detail-header-sns-img" style="border:1px solid #fff">
              <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
            </el-image>
          </div>
          <div class="i-detail-header-similar-description">類似<br />アカウント</div>
        </div>
        <div v-if="similar_loading" class="i-detail-similar-button-wrap pointer">
          <div v-for="n in 5" :key="n">
            <div class="i-detail-similar-icon"><div class="i-detail-header-sns-img data-table-profile-noimg w-border"></div></div>
          </div>
          <div class="i-detail-header-similar-description">類似<br />アカウント</div>
        </div>
      </div>

      <div class="i-detail-wrap" v-show="!loading" :class="child == true ? 'child' : ''">
        <div class="i-detail-user-page">
          <!-- プロフィール部分 -->
          <div class="profile twitter" :style="tabs == 'post' || tabs == 'note' ? 'margin-bottom:0px' : ''">
            <div class="profile-left">
              <div class="profile-img-area" :class="tabs != 'summary' ? 'minimize' : ''">
                <div class="profile-img-wrap">
                  <el-tooltip placement="bottom">
                    <div slot="content" style="font-size:10px">
                      お気に入り<span>{{ profile_data.favorite == 0 ? "に追加" : "から削除" }}</span>
                    </div>
                    <div class="profile-img-favorite" :class="[tabs != 'summary' ? 'minimize' : '', profile_data.favorite == 0 ? 'off' : '']" @click="favorite"><font-awesome-icon icon="star" /></div>
                  </el-tooltip>
                  <el-image class="profile_img" :class="tabs != 'summary' ? 'minimize' : ''" :src="profile_data.profile_image_url">
                    <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
                  </el-image>
                </div>
              </div>
              <div class="profile-gender-area" v-if="tabs == 'summary' || tabs == 'analysis'">
                <div class="profile-title">
                  フォロワーの男女比率&nbsp;
                  <el-tooltip placement="top">
                    <div slot="content">AIにより算出したフォロワーの男女比です。<br />実際の数値とは異なる場合があります。</div>
                    <span><font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;"/></span>
                  </el-tooltip>
                </div>
                <!-- <div class="gender-bar" v-if="profile_data.female_ratio && !(profile_data.female_ratio == 0 && profile_data.male_ratio == 0)">
                  <div class="female-box" :style="{ width: profile_data.female_ratio + '%' }">
                    <font-awesome-icon icon="female" style="margin-right:6px" />
                    <div class="female-ratio">{{ profile_data.female_ratio }}</div>
                    %
                  </div>
                  <div class="male-box" :style="{ width: profile_data.male_ratio + '%' }">
                    <div class="male-ratio">{{ profile_data.male_ratio }}</div>
                    %
                    <font-awesome-icon icon="male" style="margin-left:6px" />
                  </div>
                </div> -->
                <div class="no-data">現在データがありません</div>
                <!-- <div class="profile-gender-detail-wrap" v-if="profile_data.audience">
                  <div class="profile-gender-detail-female" :style="'width:' + profile_data.female_ratio + '%'">
                    <el-tooltip v-for="female_audience in profile_data.audience.female" :key="female_audience.name">
                      <div slot="content">
                        <div style="margin-bottom: 3px;"><font-awesome-icon icon="female" style="margin-right:6px" />{{ female_audience.name }}</div>
                        <div>{{ female_audience.data }}%</div>
                      </div>
                      <div class="female-box detail" :style="{ width: female_audience.width + '%' }"></div>
                    </el-tooltip>
                  </div>
                  <div class="profile-gender-detail-center" :style="profile_data.male_ratio > profile_data.female_ratio ? 'right:0px' : ''" v-if="profile_data.audience.female.length == 3">
                    <div class="profile-gender-detail-title">13-24</div>
                    <div class="profile-gender-detail-title">25-44</div>
                    <div class="profile-gender-detail-title">45+</div>
                  </div>
                  <div class="profile-gender-detail-center" :style="profile_data.male_ratio > profile_data.female_ratio ? 'right:0px' : ''" v-else>
                    <div class="profile-gender-detail-title">13-17</div>
                    <div class="profile-gender-detail-title">18-24</div>
                    <div class="profile-gender-detail-title">25-34</div>
                    <div class="profile-gender-detail-title">35-44</div>
                    <div class="profile-gender-detail-title">45-54</div>
                    <div class="profile-gender-detail-title">55+</div>
                  </div>
                  <div class="profile-gender-detail-male" :style="'width:' + profile_data.male_ratio + '%'">
                    <el-tooltip v-for="male_audience in profile_data.audience.male" :key="male_audience.name">
                      <div slot="content">
                        <div style="margin-bottom: 3px;"><font-awesome-icon icon="male" style="margin-right:6px" />{{ male_audience.name }}</div>
                        <div>{{ male_audience.data }}%</div>
                      </div>
                      <div class="male-box detail" :style="{ width: male_audience.width + '%' }"></div>
                    </el-tooltip>
                  </div>
                </div> -->
              </div>
              <div class="profile-category" v-show="tabs == 'summary' || tabs == 'post'">
                <div class="profile-title">
                  関連カテゴリ
                  <el-tooltip placement="top">
                    <div slot="content">ポストやプロフィール文章から分析・算出を行った関連カテゴリーです。<br />()内の数値は関連度を示しています。</div>
                    <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                  </el-tooltip>
                </div>
                <div v-if="profile_data.category.category_data" class="category-box-wrap">
                  <div class="category-box pointer" v-for="category in profile_data.category.category_data" :key="category.category_name" @click="searchMedia('category', category.category_name)">
                    <font-awesome-icon icon="tag" style="margin-right:1px; font-size:10px" />
                    {{ category.category_name }}<span style="font-size: 10px">({{ category.category_ratio | decimal }}%)</span>
                  </div>
                </div>
                <div class="no-data" v-else>関連カテゴリはありません</div>
              </div>
            </div>
            <div class="profile-right">
              <div class="profile-username">
                <div class="profile-username-box accountname" :class="tabs != 'summary' ? 'minimize' : ''">
                  <div>
                    <div class="flex-row">
                      {{ profile_data.account_name }}
                      <font-awesome-icon :icon="['fas', 'badge-check']" v-show="profile_data.verified == '1'" class="tw-badge" style="font-size:18px" />
                      <el-tooltip content="[Adminメニュー] ユーザー名をコピー" placement="top" :disabled="activate != 20 || !admin_mode">
                        <font-awesome-icon
                          v-if="activate == 20 && admin_mode"
                          class="admin-button pointer"
                          :icon="['far', 'copy']"
                          style="margin: 0 10px;"
                          @click="copyLinkName(profile_data.account_name)"
                        />
                      </el-tooltip>
                      <el-tooltip content="[Adminメニュー] データ取得コードをコピー" placement="top" :disabled="activate != 20 || !admin_mode">
                        <font-awesome-icon v-if="activate == 20 && admin_mode" class="admin-button pointer" :icon="['far', 'code']" @click="copyGetLink(profile_data.account_name)" />
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="profile-sort-keyword-wrap">
                    <div v-if="search_type != 'all' && tabs == 'post'" class="profile-sort-keyword">
                      「{{ formattedSearchKeyword }}」の投稿
                      <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#333" class="pointer" @click="searchMedia('all', '')" />
                    </div>
                    <div v-if="sort_period != 'all' && tabs == 'post'" class="profile-sort-keyword">
                      {{ sort_period == "1month" ? "直近30日" : sort_period == "3month" ? "直近90日" : sort_period == "6month" ? "直近180日" : "" }}の投稿
                      <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#333" class="pointer" @click="sortMediaBy('timestamp', 'all', '投稿日が新しい順')" />
                    </div>
                  </div>
                </div>

                <div class="profile-username-box">
                  <addListDetail
                    ref="add_list_detail"
                    :influencer_id="profile_data.tw_id"
                    :list_count="profile_data.list_count"
                    :add_delete_index="add_delete_index"
                    :add_delete_loading="add_delete_loading"
                    :sns_type="'twitter'"
                    @addInfluencer="addInfluencer"
                    @deleteInfluencer="deleteInfluencer"
                  />
                  <a :href="'https://x.com/' + profile_data.account_name" target="_blank" class="profile_link">
                    <el-tooltip content="Xでアカウントを表示" placement="top">
                      <el-button type="info" style="margin-left:10px;">
                        <svg width="13" height="13" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
                        </svg>
                      </el-button>
                    </el-tooltip>
                  </a>
                </div>
              </div>
              <div class="profile_follower" v-if="tabs == 'summary' || tabs == 'analysis'">
                <div class="profile_num followers">
                  <div class="num_title">フォロワー数</div>
                  <div>
                    <span class="num">{{ profile_data.followers_count }}</span
                    >万人
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.followers_count / 30) * 100 + '%'" :class="profile_data.followers_count < 1 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title">
                    EGR
                    <el-tooltip placement="top">
                      <div slot="content">
                        直近90日の1投稿あたりの平均エンゲージメント率(EngagementRate)を示しています。 <br />いいね数とリプライ数とリポスト数の合計をフォロワー数で割った比率です。
                      </div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.average_engagement_rate }}</span>
                    %
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.average_engagement_rate * 100) / 4 + '%'" :class="profile_data.average_engagement_rate < 1.5 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title small">
                    平均いいね
                    <el-tooltip placement="top" :content="'直近90日の1投稿あたりの平均いいね数を示しています。'">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.average_like_count }}</span>
                    件
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power"
                         :style="{width: Math.min(100, Math.max(0, ((Number(profile_data.average_like_count) || 0) * 100) / 1000)) + '%'}"
                         :class="((Number(profile_data.average_like_count) || 0) < 150 ? 'danger' : '')"></div>
                  </div>
                </div>
                <div class="profile_num pr_rate">
                  <div class="num_title">
                    PR率
                    <el-tooltip placement="top">
                      <div slot="content">直近90日の投稿に占めるPR投稿の比率です。<br />20%を超えるとPR・広告色が強い印象を受ける可能性が高まります。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.pr_rate }}</span
                    >%
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + (100 - profile_data.pr_rate * 3) + '%'" :class="profile_data.pr_rate > 15 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div class="profile_num followers">
                  <div class="num_title">
                    フォロワー増加率
                    <el-tooltip placement="top" :content="'直近90日のフォロワー増加率を示しています。'">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span v-if="profile_data.followers_growth_rate > 0">+ </span>
                    <span class="num">{{ profile_data.followers_growth_rate | growthrate }}</span>
                    %
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.followers_growth_rate * 100) / 10 + '%'" :class="profile_data.followers_growth_rate < 0 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title">
                    投稿頻度
                    <el-tooltip placement="top" :content="'直近90日の投稿頻度を示しています。'">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.tweet_frequency | frequency }}</span
                    >件/週
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.media_frequency / 7) * 100 + '%'" :class="profile_data.media_frequency < 2 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title small">
                    平均リポスト
                    <el-tooltip placement="top" content="直近90日の1投稿あたりの平均リポスト数を示しています。">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.average_retweet_sum_count }}</span
                    >件
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.average_retweet_sum_count * 100) / 50 + '%'" :class="profile_data.average_retweet_sum_count < 10 ? 'danger' : ''"></div>
                  </div>
                </div>

                <div class="profile_num pr_rate">
                  <div class="num_title">総投稿数</div>
                  <div>
                    <span class="num">{{ profile_data.tweet_count }}</span
                    >件
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + profile_data.tweet_count + '%'" :class="profile_data.tweet_count < 25 ? 'danger' : ''"></div>
                  </div>
                </div>
                <!-- <div class="profile_num followers" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    登録者増加率
                    <el-tooltip placement="top">
                      <div slot="content">直近90日間におけるチャンネル登録者の増加率を示しています。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span v-if="profile_data.subscriber_growth_rate_90 > 0">+ </span>
                    <span class="num">{{ profile_data.subscriber_growth_rate_90 | growthrate }}</span
                    >%
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.subscriber_growth_rate_90 * 10 + '%'" :class="profile_data.subscriber_growth_rate_90 < 0 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    視聴数増加率
                    <el-tooltip placement="top" content="直近90日間における総再生回数の増加率を示しています。">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span v-if="profile_data.viewCount_growth_rate_90 > 0">+ </span>
                    <span class="num">{{ profile_data.viewCount_growth_rate_90 | growthrate }}</span
                    >%
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.viewCount_growth_rate_90 * 10 + '%'" :class="profile_data.viewCount_growth_rate_90 < 0 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div> -->
                <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    投稿頻度
                    <el-tooltip placement="top" content="直近90日の平均投稿頻度です。">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.media_frequency }}</span
                    >/週
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + (profile_data.media_frequency * 100) / 7 + '%'" :class="profile_data.media_frequency < 1 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <!-- <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">平均動画時間</div>
                  <div v-if="activate > 10">
                    <span class="num">{{ profile_data.average_duration }}</span
                    >分
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.average_duration * 7 + '%'" :class="profile_data.average_duration < 1 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div> -->
              </div>
              <div v-if="tabs == 'summary'">
                <div class="profile_name">
                  <div class="profile-feature" v-if="profile_data.name">
                    <b>{{ profile_data.name }}</b>
                    <span style="margin:0 10px" v-if="profile_data.age || profile_data.gender == '男性' || profile_data.gender == '女性' || profile_data.gender == 'グループ'">|</span>
                  </div>
                  <div class="profile-feature" v-if="profile_data.age">
                    {{ profile_data.age }}歳
                    <el-tooltip :class="printmode ? 'printmode' : ''">
                      <div slot="content">過去の投稿やWebの情報から推測される年齢です。<br />実際の年齢と異なる場合があります。</div>
                      <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
                    </el-tooltip>
                    <span style="margin:0 10px">|</span>
                  </div>
                  <div class="profile-feature" v-if="profile_data.gender == '男性' || profile_data.gender == '女性' || profile_data.gender == 'グループ'">
                    <span v-if="profile_data.gender == '女性'"><font-awesome-icon :icon="['fas', 'female']" style="color:#f56c6c; margin-right: 5px;" />女性</span>
                    <span v-if="profile_data.gender == '男性'"><font-awesome-icon :icon="['fas', 'male']" style="color:#0095f6; margin-right: 5px;" />男性</span>
                    <span v-if="profile_data.gender == 'グループ'"><font-awesome-icon :icon="['fas', 'user-group']" style="color:#aaa; margin-right: 5px;" />グループ</span>
                  </div>
                </div>
                <div class="profile_bio">
                  <pre v-html="$options.filters.tweetFilter(profile_data.description, null, null)"></pre>
                </div>
                <div class="flex-row profile-additional-info">
                  <div class="twitter-weblink flex-row" v-show="profile_data.expanded_url">
                    <font-awesome-icon :icon="['far', 'link']" style="margin-right: 5px;" />
                    <a :href="profile_data.expanded_url" v-if="profile_data.expanded_url" target="_blank" class="profile_website pointer">
                      {{ profile_data.expanded_url }}
                    </a>
                  </div>
                  <div class="twitter-location flex-row" v-show="profile_data.location">
                    <font-awesome-icon :icon="['far', 'map-marker-alt']" style="margin-right: 5px;" />
                    <span class="profile-location">{{ profile_data.location }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="search-form-youtube" v-if="tabs == 'post'">
            <div class="header-search-wrap instagram" style="width: 180px; margin-right: 10px" :style="inputfocus ? 'width: 100%' : ''">
              <font-awesome-icon :icon="['fas', 'search']" style="font-size:16px; color:#aaa; margin-right:10px" />
              <postSearchInput :inputfocus.sync="inputfocus" :inputkeyword.sync="inputkeyword" @searchKeyword="searchMedia" />
            </div>
            <div class="flex-space"></div>
            <div v-if="tabs == 'post' && tweet_count > 0">
              <el-pagination
                @current-change="pageChange"
                :current-page.sync="currentPage"
                background
                layout="prev, pager, next"
                :total="tweet_count"
                :page-size="pagesize"
                :pager-count="5"
                small
              ></el-pagination>
            </div>
            <el-checkbox :value="search_type == 'pr'" @change="search_type == 'pr' ? searchMedia('all', '') : searchMedia('pr', 'PR投稿')" style="display:flex; align-items:center;">
              <el-tooltip placement="bottom">
                <div slot="content">「#PR」などのPR表記のある投稿のみを表示します。</div>
                <span style="font-size:11px; color:#666; ">PR投稿のみを表示</span>
              </el-tooltip>
            </el-checkbox>
            <el-dropdown trigger="click" style="margin-left: 20px">
              <el-button type="info" class="report-media-sort-button">
                {{ media_sort }}
                <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :class="media_sort == '投稿日が新しい順'" :disabled="media_sort == '投稿日が新しい順'" @click.native="sortMediaBy('timestamp', 'all', '投稿日が新しい順')"
                  >投稿日が新しい順</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'いいね数が多い順(直近30日)' ? 'assign' : ''"
                  :disabled="media_sort == 'いいね数が多い順(直近30日)'"
                  @click.native="sortMediaBy('like_count', '1month', 'いいね数が多い順(直近30日)')"
                  >いいね数が多い順(直近30日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'いいね数が多い順(直近90日)' ? 'assign' : ''"
                  :disabled="media_sort == 'いいね数が多い順(直近90日)'"
                  @click.native="sortMediaBy('like_count', '3month', 'いいね数が多い順(直近90日)')"
                  >いいね数が多い順(直近90日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'いいね数が多い順(直近180日)' ? 'assign' : ''"
                  :disabled="media_sort == 'いいね数が多い順(直近180日)'"
                  @click.native="sortMediaBy('like_count', '6month', 'いいね数が多い順(直近180日)')"
                  >いいね数が多い順(直近180日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'いいね数が多い順(全期間)' ? 'assign' : ''"
                  :disabled="media_sort == 'いいね数が多い順(全期間)'"
                  @click.native="sortMediaBy('like_count', 'all', 'いいね数が多い順(全期間)')"
                  >いいね数が多い順(全期間)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近30日)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近30日)'"
                  @click.native="sortMediaBy('engagement_count', '1month', 'エンゲージメントが多い順(直近30日)')"
                  >エンゲージメントが多い順(直近30日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近90日)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近90日)'"
                  @click.native="sortMediaBy('engagement_count', '3month', 'エンゲージメントが多い順(直近90日)')"
                  >エンゲージメントが多い順(直近90日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近180日)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近180日)'"
                  @click.native="sortMediaBy('engagement_count', '6month', 'エンゲージメントが多い順(直近180日)')"
                  >エンゲージメントが多い順(直近180日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(全期間)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(全期間)'"
                  @click.native="sortMediaBy('engagement_count', 'all', 'エンゲージメントが多い順(全期間)')"
                  >エンゲージメントが多い順(全期間)</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- 投稿リスト部分 -->
          <div v-if="tweet_count > 0">
            <div class="tweet-list-wrap" v-show="profile_data.tweet_count > 0 && (tabs == 'summary' || tabs == 'post')">
              <div class="tweet-item" v-for="(tweet, index) in tweet_data" :key="tweet.id" @click="detail(index)">
                <div class="tweet-author">
                  <div><img :src="profile_data.profile_image_url" class="tweet-author-img" /></div>
                  <div class="flex-column">
                    <div class="tweet-author-name">
                      {{ profile_data.name }}
                      <font-awesome-icon :icon="['fas', 'badge-check']" class="tw-badge small" v-show="profile_data.verified == '1'" />
                    </div>
                    <div class="tweet-author-username">{{ profile_data.account_name }}</div>
                  </div>
                  <div class="flex-space"></div>
                  <div class="pr_tag twitter" v-show="tweet.pr_flag">PR</div>
                </div>
                <div class="tweet-text">
                  <pre style="margin:0" v-html="$options.filters.tweetFilter(tweet.text, search_type, search_type == 'keyword' ? search_keyword : search_type == 'pr' ? pr_word : '')"></pre>
                </div>
                <div class="tweet-quote" v-if="tweet.includes_quote">
                  <div class="tweet-author" v-if="tweet.quote.tw_id">
                    <div><img :src="tweet.quote.profile_image_url" class="tweet-author-img" /></div>
                    <div class="flex-column">
                      <div class="tweet-author-name">
                        {{ tweet.quote.name }}
                        <font-awesome-icon :icon="['fas', 'badge-check']" class="tw-badge small" v-show="tweet.quote.verified == '1'" />
                      </div>
                      <div>{{ tweet.quote.account_name }}</div>
                    </div>
                    <div class="flex-space"></div>
                  </div>
                  <pre style="margin:0;" class="w-100 tweet-quote-text">{{ tweet.quote.text }}</pre>
                  <div>{{ tweet.created_at }}</div>
                </div>
                <div v-else-if="tweet.includes_media" class="tweet-photo-wrap" :class="'length-' + tweet.media_list.length">
                  <div
                    v-for="(media, media_index) in tweet.media_list"
                    :key="media.media_key"
                    class="tweet-photo"
                    :class="['length-' + tweet.media_list.length, 'no-' + media_index]"
                    @click="initial_media_index = media_index"
                  >
                    <img :src="media.url + '?name=360x360'" class="tweet-photo-img" />
                  </div>
                </div>
                <div v-else-if="tweet.includes_video">
                  <video :src="tweet.media_list[0].url" autoplay muted loop controls class="tweet-video"></video>
                </div>
                <a v-else-if="tweet.includes_urls_images" :href="tweet.entities.urls[0].expanded_url" target="_blank" style="width:100%">
                  <div class="tweet-urls pointer">
                    <img :src="tweet.entities.urls[0].images[0].url" class="tweet-urls-images" />
                    <div class="flex-column w-100" style="padding:10px">
                      <div class="tweet-urls-url">{{ tweet.entities.urls[0].display_url }}</div>
                      <div class="tweet-urls-title">{{ tweet.entities.urls[0].title }}</div>
                      <div class="tweet-urls-description">{{ tweet.entities.urls[0].description }}</div>
                    </div>
                  </div>
                </a>
                <div class="flex-space"></div>
                <div class="tweet-metrics">
                  <div>
                    <font-awesome-icon :icon="['far', 'comment']" style="margin-right: 3px;" />
                    {{ tweet.reply_count }}
                  </div>
                  <div>
                    <font-awesome-icon :icon="['far', 'retweet']" style="margin-right: 3px;" />
                    {{ tweet.retweet_count }}
                  </div>
                  <div>
                    <font-awesome-icon :icon="['far', 'square-quote']" style="margin-right: 3px;" />
                    {{ tweet.quote_count }}
                  </div>
                  <div>
                    <font-awesome-icon :icon="['far', 'heart']" style="margin-right: 3px;" />
                    {{ tweet.like_count }}
                  </div>
                </div>
                <div>{{ tweet.created_at }}</div>
              </div>
            </div>
          </div>
          <div class="no-media-message" v-else-if="profile_data.protected != '1' && tweet_count == 0">
            <img src="../../assets/post_image.png" style="opacity:0.5" alt />
            <div>{{ no_media_message }}</div>
          </div>
          <div class="gallery-wrap-private" v-else>このアカウントは非公開か削除されています</div>

          <div class="pagenation-wrap" v-if="(tabs == 'summary' || tabs == 'post') && tweet_count > 0">
            <el-pagination @current-change="pageChange" :current-page.sync="currentPage" background layout="prev, pager, next" :total="tweet_count" :page-size="pagesize"></el-pagination>
          </div>

          <div class="overlay-sub overlay" :class="drawer ? 'open' : ''" @click="drawer = false"></div>
          <div class="media-detail-modal twitter" :class="drawer ? 'open' : ''">
            <div class="detail-modal twitter" v-if="drawer">
              <div class="detail-profile-wrap">
                <div class="detail-profile-img-area">
                  <el-image class="detail-profile_img" :src="profile_data.profile_image_url">
                    <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
                  </el-image>
                </div>
                <div class="detail-profile-name-area">
                  <div class="detail-profile-name">
                    {{ profile_data.name }}
                    <font-awesome-icon :icon="['fas', 'badge-check']" class="tw-badge" v-show="profile_data.verified == '1'" />
                  </div>
                  <div class="detail-location">{{ profile_data.account_name }}</div>
                </div>
                <div class="flex-space"></div>
                <div>
                  <a :href="'https://x.com/' + profile_data.account_name + '/status/' + tweet_data[index].tweet_id" target="_blank">
                    <el-button type="info" size="mini" style="margin-left:10px;">X→</el-button>
                  </a>
                </div>
              </div>
              <div class="pr_type twitter" v-show="tweet_data[index].pr_flag">
                <div class="pr_tag twitter">PR</div>
              </div>
              <div class="tweet-text-detail">
                <pre v-html="$options.filters.tweetFilter(tweet_data[index].text, search_type, search_type == 'keyword' ? search_keyword : search_type == 'pr' ? pr_word : '')"></pre>
                <div class="tweet-quote" v-if="tweet_data[index].includes_quote">
                  <div class="tweet-author" v-if="tweet_data[index].quote.tw_id">
                    <div><img :src="tweet_data[index].quote.profile_image_url" class="tweet-author-img" /></div>
                    <div class="flex-column">
                      <div class="tweet-author-name">
                        {{ tweet_data[index].quote.name }}
                        <font-awesome-icon :icon="['fas', 'badge-check']" class="tw-badge small" v-show="tweet_data[index].quote.verified == '1'" />
                      </div>
                      <div>{{ tweet_data[index].quote.account_name }}</div>
                    </div>
                    <div class="flex-space"></div>
                  </div>
                  <pre style="margin:0">{{ tweet_data[index].quote.text }}</pre>
                  <div>{{ tweet_data[index].created_at }}</div>
                </div>
                <a v-else-if="tweet_data[index].includes_urls_images" :href="tweet_data[index].entities.urls[0].expanded_url" target="_blank">
                  <div class="tweet-urls pointer">
                    <img :src="tweet_data[index].entities.urls[0].images[0].url" class="tweet-urls-images" />
                    <div class="flex-column w-100" style="padding:10px">
                      <div class="tweet-urls-url">{{ tweet_data[index].entities.urls[0].display_url }}</div>
                      <div class="tweet-urls-title">{{ tweet_data[index].entities.urls[0].title }}</div>
                      <div class="tweet-urls-description">{{ tweet_data[index].entities.urls[0].description }}</div>
                    </div>
                  </div>
                </a>
                <div class="tweet-metrics">
                  <div>
                    <font-awesome-icon :icon="['far', 'comment']" style="margin-right: 3px;" />
                    {{ tweet_data[index].reply_count }}
                  </div>
                  <div>
                    <font-awesome-icon :icon="['far', 'retweet']" style="margin-right: 3px;" />
                    {{ tweet_data[index].retweet_count }}
                  </div>
                  <div>
                    <font-awesome-icon :icon="['far', 'square-quote']" style="margin-right: 3px;" />
                    {{ tweet_data[index].quote_count }}
                  </div>
                  <div>
                    <font-awesome-icon :icon="['far', 'heart']" style="margin-right: 3px;" />
                    {{ tweet_data[index].like_count }}
                  </div>
                </div>
                <div>{{ tweet_data[index].created_at }}</div>
              </div>
              <div class="tweet-detail-photo" v-if="tweet_data[index].includes_media">
                <el-carousel :arrow="tweet_data[index].media_list[1] ? 'always' : 'never'" indicator-position="none" height="600px" :initial-index="initial_media_index">
                  <el-carousel-item v-for="media in tweet_data[index].media_list" :key="media.media_key" class="tweet-detail-photo-wrap" @click.native="drawer = false">
                    <img :src="media.url" class="tweet-detail-photo-img" />
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="tweet-detail-photo" v-if="tweet_data[index].includes_video">
                <video :src="tweet_data[index].media_list[0].url" autoplay muted loop controls class="tweet-video modal"></video>
              </div>
            </div>
          </div>

          <div v-observe-visibility="{ callback: similarVisible }"></div>

          <!-- フォロワー推移データ -->
          <transitionData :sns_type="'twitter'" :loading="loading" :id="profile_data.tw_id" v-show="tabs == 'summary' || tabs == 'analysis'" />
          <!-- 視聴率分布 -->
          <!-- <distributionChart
            :avg_data="avg_data.vr"
            :name="profile_data.channel_name"
            :own_data="profile_data.average_viewRate_3month"
            :type="'vr'"
            :sns_type="'youtube'"
            v-show="tabs == 'summary' || tabs == 'analysis'"
          /> -->

          <!-- ノート -->
          <note
            v-if="tabs == 'note'"
            :id="profile_data.tw_id"
            :sns_type="'twitter'"
            ref="note"
            @commentReactive="commentReactive"
            @statusReactive="statusReactive"
            @noteReactive="noteReactive"
            @tagReactive="tagReactive"
          />

          <div id="i-detail-similar"></div>

          <!-- 類似アカウント -->
          <similarAccount
            ref="similarAccount"
            v-if="similar_show"
            :sns_type="'twitter'"
            :similar_data="similar_data"
            @toInfluencerDetail="toInfluencerDetail"
            @toInfluencerDetailNewWindow="toInfluencerDetailNewWindow"
          />
        </div>
      </div>
    </div>
    <div class="loader-detail" v-show="!mounted || loading"></div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const showTwitterAPI = root + "/api/search/show_twitter";
const loadSimilarAccountAPI = root + "/api/search/load_similar_twitter";
const loadListAPI = root + "/api/list/load_list";
const addInfluencerAPI = root + "/api/list/add_influencer";
const deleteInfluencerAPI = root + "/api/list/delete_influencer";
const addFavoriteAPI = root + "/api/list/add_favorite";

// import "./twitter.js";
import transitionData from "./transitionData";
import postSearchInput from "./postSearchInput";
import note from "./note.vue";
// import distributionChart from "./detail_component/distribution_chart";
import addListDetail from "./detail_component/add_list_detail";
import otherSNS from "./other_sns.vue";
import similarAccount from "./detail_component/similar_account";
import { handleApiResponse } from "@/components/common/responseHelper";

export default {
  name: "twittererDetail",
  components: {
    transitionData,
    postSearchInput,
    note,
    // distributionChart,
    addListDetail,
    otherSNS,
    similarAccount,
  },
  beforeRouteLeave(to, from, next) {
    if (to.name.match(/twittererDetail/i)) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_twittererDetailDrawer" : "twittererDetail",
        params: {
          account_name: to.params.account_name,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    } else if (to.name == "twittererDetail" && this.child) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_twittererDetailDrawer" : "twittererDetail",
        params: {
          account_name: to.params.account_name,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    } else {
      next();
    }
  },
  props: {
    account_name: String,
    child: Boolean,
    parent_component: String,
    influencer_index: Number,
    default_search: Boolean,
  },
  data() {
    return {
      tw_id: "",
      channel_name: "",
      currentPage: 1,
      tweet_count: 0,
      pagesize: 30,
      profile_data: [],
      egr_data: [],
      tweet_data: [],
      similar_data: [],
      similar_loading: true,
      similar_show: false,
      no_media_message: "",
      list: [],
      active_list_count: "",
      sort_key: "timestamp",
      sort_period: "all",
      media_sort: "投稿日が新しい順",
      sort_similar_description: "並び替え",
      mounted: false,
      drawer: false,
      index: 0,
      initial_media_index: 0,
      loading: false,
      add_delete_loading: false,
      add_delete_index: "",
      detail_loading: false,
      inputfocus: false,
      inputkeyword: "",
      actionId: new Date(),
      search_keyword: "",
      search_type: "all",
      search_dropdown: "",
      search_dropdown_regexp: "",
      search_dropdown_add: "",
      search_dropdown_add_regexp: "",
      get_account_name: "",
      get_account_name_post: "",
      requestId: 0,
      tabs: "summary",
      pr_regexp: "",
      pr_word: "#pr|#promotion|#sponsored|#.+_pr|#.+_sponsored|#.+_ad|#.+_partner|#supported|#.+_supported",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    printmode() {
      return false;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    similar_account() {
      return this.similar_data.slice(0, 5);
    },
    formattedSearchKeyword() {
      if (this.search_type === 'category') {
        // 配列の場合のみ .map を実行
        return Array.isArray(this.search_keyword)
            ? this.search_keyword.map(item => item.slice(-1)[0]).join(' ')
            : this.search_keyword;
      }
      // 配列でない場合はそのまま返す
      return this.search_keyword || '';
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.loading = true;
      if (this.default_search == true) {
        this.search_type = this.$route.params.search_type;
        this.search_keyword = this.$route.params.search_keyword;
        this.searchMedia(this.search_type, this.search_keyword);
        this.loadList();
      } else {
        this.axios
          .get(showTwitterAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              account_name: this.account_name,
              search_type: "all",
            },
          })
          .then((response) => {
            if (handleApiResponse(response)) {
              // ステータスがNGの場合
              this.$message.error(response.data.message);
              this.$nextTick(() => {
                this.$router.push({ name: 'twitterer' });
              });
              return;
            }
            this.mounted = true;
            this.loading = false;
            this.profile_data = response.data.profile_data;
            this.no_media_message = response.data.no_media_message;
            this.avg_data = response.data.avg_data;
            this.tweet_data = response.data.tweet_data;
            this.tweet_count = response.data.tweet_count;
            this.tw_id = response.data.profile_data.tw_id;
            this.tweet_count == 0 ? (this.loading = false) : "";
            this.loadSimilarAccount();
          });
      }
    },
    loadSimilarAccount() {
      this.axios.cancel(this.requestId_similar);
      this.requestId_similar += 1;
      this.similar_loading = true;
      this.axios
        .get(loadSimilarAccountAPI, {
          requestId: this.requestId_similar,
          params: {
            token: this.token,
            tw_id: this.tw_id,
          },
        })
        .then((response) => {
          this.similar_data = response.data.similar_data;
          this.similar_loading = false;
        })
        .catch(() => {});
    },
    similarVisible(isVisible) {
      if (isVisible && !this.similar_show) {
        this.similar_show = true;
      }
    },
    loadList() {
      this.axios
        .get(loadListAPI, {
          params: {
            token: this.token,
            type: "min",
            sns_type: "twitter",
            influencer: this.profile_data.tw_id,
          },
        })
        .then((response) => {
          this.list = response.data.mylist;
          this.active_list_count = response.data.active_list_count;
        });
    },
    addInfluencer(id, name, index) {
      this.add_delete_loading = true;
      this.add_delete_index = index;
      const tw_id = this.profile_data.tw_id;
      const tw_id_js = [tw_id];
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("influencer", JSON.stringify(tw_id_js));
      params.append("sns_type", "twitter");
      params.append("token", this.token);
      this.axios.post(addInfluencerAPI, params).then(() => {
        this.add_delete_loading = false;
        this.profile_data.list_count += 1;
        this.$refs.add_list_detail.loadList();
        this.$emit("loadFromDetail", id);
        this.$emit("addInfluencerReactive", this.influencer_index, name, id);
        this.checkList = [];
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.profile_data.account_name + "を" + name + "に追加しました",
        });
        this.$store.dispatch("loadSidemenuOption", this.token);
        if (this.tabs == "note") {
          this.$refs.note.loadNote(false);
        }
      });
    },
    deleteInfluencer(id, name, index) {
      this.add_delete_loading = true;
      this.add_delete_index = index;
      const tw_id = this.profile_data.tw_id;
      const tw_id_js = [tw_id];
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("sns_type", "twitter");
      params.append("influencer", JSON.stringify(tw_id_js));
      params.append("token", this.token);
      this.axios.post(deleteInfluencerAPI, params).then(() => {
        this.add_delete_loading = false;
        this.profile_data.list_count -= 1;
        this.$refs.add_list_detail.loadList();
        this.$emit("loadFromDetail", id);
        this.$emit("deleteInfluencerReactive", this.influencer_index, id);
        this.checkList = [];
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.profile_data.account_name + "を" + name + "から削除しました",
        });
        if (this.tabs == "note") {
          this.$refs.note.loadNote(false);
        }
      });
    },
    pageChange(currentPage) {
      this.loading = true;
      this.currentPage = currentPage;
      this.tweet_data = [];
      this.requestId += 1;
      this.axios
        .get(showTwitterAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            account_name: this.account_name,
            currentPage: this.currentPage,
            search_type: this.search_type,
            search_keyword: this.search_keyword,
            sort_key: this.sort_key,
            sort_period: this.sort_period,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            // ステータスがNGの場合
            this.$message.error(response.data.message);
            this.$nextTick(() => {
              this.$router.push({ name: 'twitterer' });
            });
            return;
          }
          this.loading = false;
          this.profile_data = response.data.profile_data;
          this.no_media_message = response.data.no_media_message;
          this.avg_data = response.data.avg_data;
          this.tweet_data = response.data.tweet_data;
          this.tweet_count = response.data.tweet_count;
          this.tweet_count == 0 ? (this.loading = false) : "";
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.actionId += 1;
        });
    },
    searchMedia(type, keyword) {
      this.loading = true;
      this.click_loading = true;
      this.currentPage = 1;
      this.tabs = "post";
      if (this.search_type != type || this.search_keyword != keyword) {
        this.media_sort = "投稿日が新しい順";
        this.sort_key = "timestamp";
        this.sort_period = "all";
      }
      if (type !== "keyword") this.inputkeyword = "";
      if (type == "keyword" && keyword == "") type = "all";
      this.search_type = type;
      this.search_keyword = keyword;
      this.requestId += 1;
      this.tweet_data = [];
      this.axios
        .get(showTwitterAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            account_name: this.account_name,
            currentPage: 1,
            search_type: this.search_type,
            search_keyword: this.search_keyword,
            sort_key: this.sort_key,
            sort_period: this.sort_period,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            // ステータスがNGの場合
            this.$message.error(response.data.message);
            this.$nextTick(() => {
              this.$router.push({ name: 'twitterer' });
            });
            return;
          }
          this.loading = false;
          this.mounted = true;
          this.profile_data = response.data.profile_data;
          this.no_media_message = response.data.no_media_message;
          this.avg_data = response.data.avg_data;
          this.tweet_data = response.data.tweet_data;
          this.tweet_count = response.data.tweet_count;
          this.tweet_count == 0 ? (this.loading = false) : "";
          if (this.search_type == "pr") this.pr_regexp = response.data.search_word;
          this.loadSimilarAccount();
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.actionId += 1;
        });
    },
    sortMediaBy(sort_key, sort_period, sort_description) {
      this.sort_key = sort_key;
      this.sort_period = sort_period;
      this.media_sort = sort_description;
      this.searchMedia(this.search_type, this.search_keyword);
    },
    resetSearchMedia() {
      this.search_type = "all";
      this.search_keyword = "";
      this.sort_key = "timestamp";
      this.sort_period = "all";
      this.media_sort = "投稿日が新しい順";
      this.inputkeyword = "";
      this.currentPage = 1;
    },
    detail(index) {
      (this.drawer = true), (this.index = index);
      this.detail_loading = true;
      this.actionId += 1;
    },
    favorite() {
      if (this.profile_data.favorite == 0) {
        this.profile_data.favorite = 1;
      } else {
        this.profile_data.favorite = 0;
      }
      var params = new URLSearchParams();
      params.append("influencer", this.profile_data.tw_id);
      params.append("sns_type", "twitter");
      params.append("favorite", this.profile_data.favorite);
      params.append("token", this.token);
      this.axios.post(addFavoriteAPI, params);
      this.$emit("favoriteReactive", this.influencer_index, this.profile_data.favorite);
    },
    toSetting() {
      this.$router.push("/setting");
    },
    closeParentDrawer() {
      this.drawer = false;
    },
    closeParentDrawerClear() {
      this.resetSearchMedia();
      this.loading = true;
    },
    openParentDrawer() {
      this.child = true;
    },
    searchDropdown(value) {
      this.search_dropdown_regexp = new RegExp(value, "ig");
    },
    searchDropdownAdd(value) {
      this.search_dropdown_add_regexp = new RegExp(value, "ig");
    },
    scrollBottom() {
      if (this.shimilar_show) {
        document.getElementById("i-detail-similar").scrollIntoView({ block: "start", behavior: "smooth" });
      } else {
        this.similar_show = true;
        setTimeout(() => {
          document.getElementById("i-detail-similar").scrollIntoView({ block: "start", behavior: "smooth" });
        }, 100);
      }
    },
    toInfluencerDetail(account_name) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_twittererDetailDrawer" : "twittererDetail",
        params: {
          account_name: account_name,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    toInfluencerDetailNewWindow(account_name) {
      let routeData = this.$router.resolve({
        name: "twittererDetail",
        params: {
          account_name: account_name,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    changeTab(tab) {
      this.loading = true;
      if (this.tabs == "post" && tab != "post" && (this.search_type != "all" || this.sort_period != "all")) {
        this.resetSearchMedia();
        this.searchMedia("all", "");
        this.tabs = tab;
      } else {
        setTimeout(() => {
          this.tabs = tab;
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.loading = false;
        }, 0);
      }
    },
    commentReactive(comment, list_id) {
      this.$emit("commentReactive", this.profile_data.tw_id, comment, list_id);
    },
    statusReactive(status, list_id) {
      this.$emit("statusReactive", this.profile_data.tw_id, status, list_id);
    },
    noteReactive(note_info, property_name) {
      this.$emit("noteReactive", this.profile_data.tw_id, note_info, property_name);
    },
    tagReactive(type, tag_index, new_tag) {
      this.$emit("tagReactive", this.profile_data.tw_id, type, tag_index, new_tag);
    },
    copyLinkName(account_name) {
      var text = account_name;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "ユーザー名がコピーされました",
        });
      });
    },
    copyGetLink(account_name) {
      var text = "php tw_get_single.php -a" + account_name;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "コードがコピーされました",
        });
      });
    },
  },
  filters: {
    tweetFilter(text, search_type, replace_word) {
      const url_regexp = /https?:\/\/[\w!?/+\-_~;.,*&@#$%()'[\]]+/g;
      const twitter_url_regexp = /https:\/\/twitter\.com\/.*\/status\S+/g;
      text = text.replace(url_regexp, (url) => '<a class="router-link" href="' + url + '" target="_blank">' + url + "</a>");
      text = text.replace(twitter_url_regexp, ""); //Twitterの短縮URLは表示しない
      if (search_type == "keyword") {
        const keyword_rep1 = replace_word.replace(/OR/g, "|");
        const keyword_rep2 = keyword_rep1.replace(/"/g, "");
        const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
        const keyword_RegExp = new RegExp("(?<!href=.*)" + keyword_rep3, "ig");
        text = text.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else if (search_type == "pr") {
        const keyword_RegExp = new RegExp(replace_word, "ig");
        text = text.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      }
      return text;
    },
    growthrate(val) {
      if (val == null) {
        return "NA";
      } else {
        return val;
      }
    },
    viewcount(val) {
      if (val >= 9999) {
        return Math.floor(val / 1000) / 10;
      } else {
        return val;
      }
    },
    frequency(val) {
      if (val) {
        return val;
      } else {
        return "NA";
      }
    },
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
    decimal(val) {
      return Math.floor(val);
    },
  },
  watch: {
    actionId() {
      this.$forceUpdate();
    },
    $route() {
      this.load();
      this.closeParentDrawerClear();
      this.child = true;
    },
    currentPage() {
      if (this.currentPage > 1) this.tabs = "post";
    },
    drawer() {
      if (this.drawer == false) this.initial_media_index = 0;
    },
  },
};
</script>

<style></style>
